<div class="editable-container" [ngClass]="{ 'hovered': isHovered, 'editing': isEditing }" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div *ngIf="!isEditing; else editTemplate" (click)="startEditing()">
    <span *ngIf="currentValue !== null && (currentValue || currentValue.toString() === '0'); else emptyTemplate">{{
      currentValue }}</span>
    <ng-template #emptyTemplate>
      <span class="empty-text">{{ placeholder }}</span>
    </ng-template>
  </div>
  <ng-template #editTemplate>
    <ng-container [ngSwitch]="valueType">
      <ng-container *ngSwitchCase="'Number'">
        <nz-input-number *ngSwitchCase="'Number'" #inputNumberCom [(ngModel)]="inputValue"
          [nzMin]="0"></nz-input-number>

        <div *ngIf="isEditing" class="action-group">
          <button nz-button nzType="primary" class="action-item" (click)="onBlur()"
            [nzLoading]="saveLoading">Save</button>
          <button nz-button nzDanger class="action-item" (click)="handleCancel()">Cancel</button>
        </div>
      </ng-container>

      <textarea *ngSwitchDefault #editorTextArea nz-input [(ngModel)]="inputValue" (focus)="startEditing()"
        (blur)="onBlur()" [rows]="rows" (keydown)="onKeydown($event)"></textarea>
    </ng-container>
  </ng-template>
</div>